import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { QueryClientProvider } from "@tanstack/react-query";
import AppRouter from "AppRouter";
import "react-datepicker/dist/react-datepicker.css";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import ErrorFallback from "shared/welda/components/error/ErrorFallback";
import LoadingOverlay from "shared/welda/components/loaders/LoadingOverlay";
import ToastContainerWrapper from "shared/welda/components/ToastContainerWrapper";
import { AppContextProvider } from "shared/welda/context/AppContext";
import { LoadingContextProvider } from "shared/welda/context/LoadingContext";
import useOSClasslists from "shared/welda/hooks/useOSClasslists";
import { reduxStore } from "shared/welda/stores/reduxStore";
import { queryClient } from "webshop/services/queryClient";

library.add(fab, fas, far);

const App = () => {
  useOSClasslists();
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Provider store={reduxStore}>
        <AppContextProvider>
          <QueryClientProvider client={queryClient}>
            <LoadingContextProvider>
              <LoadingOverlay />
              <ToastContainerWrapper />
              <AppRouter />
            </LoadingContextProvider>
          </QueryClientProvider>
        </AppContextProvider>
      </Provider>
    </ErrorBoundary>
  );
};

export default App;
